var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('meta',{attrs:{"name":"viewport","content":"width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"}}),_c('meta',{attrs:{"name":"apple-mobile-web-app-capable","content":"yes"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }